import { render, staticRenderFns } from "./IndagineEpidemiologicaView.vue?vue&type=template&id=1f08c422"
import script from "./IndagineEpidemiologicaView.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports